import { BilledEntity } from "dsl/billed-entity";


export const accountCheckoutPath = (billedEntity: BilledEntity) => {
  return `/account-checkout/${billedEntity.id}/`;
}